export const schema = {
    "models": {
        "CaseNote": {
            "name": "CaseNote",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "postDate": {
                    "name": "postDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "authorEmployer": {
                    "name": "authorEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "authorID"
                    }
                },
                "authorTeamMember": {
                    "name": "authorTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "authorID"
                    }
                },
                "isPinned": {
                    "name": "isPinned",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "note": {
                    "name": "note",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "caseID": {
                    "name": "caseID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "processRequestID": {
                    "name": "processRequestID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "companyID": {
                    "name": "companyID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "userGroup": {
                    "name": "userGroup",
                    "isArray": false,
                    "type": {
                        "enum": "UserGroup"
                    },
                    "isRequired": true,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "CaseNotes",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "queries": null,
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCase",
                        "fields": [
                            "caseID",
                            "userGroup",
                            "postDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byProcessRequest",
                        "fields": [
                            "processRequestID",
                            "userGroup",
                            "postDate"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "create"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "owner",
                                "allow": "owner",
                                "operations": [
                                    "update"
                                ],
                                "identityClaim": "cognito:username"
                            }
                        ]
                    }
                }
            ]
        },
        "Employer": {
            "name": "Employer",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "slug": {
                    "name": "slug",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "hasLoggedIn": {
                    "name": "hasLoggedIn",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "PersonType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "email": {
                    "name": "email",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "username": {
                    "name": "username",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "avatar": {
                    "name": "avatar",
                    "isArray": false,
                    "type": {
                        "nonModel": "Picture"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "firstname": {
                    "name": "firstname",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "middlename": {
                    "name": "middlename",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastname": {
                    "name": "lastname",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lowerFirst": {
                    "name": "lowerFirst",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "lowerLast": {
                    "name": "lowerLast",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "lowerFull": {
                    "name": "lowerFull",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "address": {
                    "name": "address",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "phone": {
                    "name": "phone",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "title": {
                    "name": "title",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "companyIDs": {
                    "name": "companyIDs",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "companies": {
                    "name": "companies",
                    "isArray": true,
                    "type": {
                        "model": "EmployerAssignment"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "employer"
                    }
                },
                "adminCompanies": {
                    "name": "adminCompanies",
                    "isArray": true,
                    "type": {
                        "model": "EmployerAdminAssignment"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "employer"
                    }
                },
                "invoicingContactCompanies": {
                    "name": "invoicingContactCompanies",
                    "isArray": true,
                    "type": {
                        "model": "InvoicingContact"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "employer"
                    }
                },
                "primaryContactCompanies": {
                    "name": "primaryContactCompanies",
                    "isArray": true,
                    "type": {
                        "model": "PrimaryContact"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "employer"
                    }
                },
                "seniorContactCompanies": {
                    "name": "seniorContactCompanies",
                    "isArray": true,
                    "type": {
                        "model": "SeniorContact"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "employer"
                    }
                },
                "signatoryContactCompanies": {
                    "name": "signatoryContactCompanies",
                    "isArray": true,
                    "type": {
                        "model": "SignatoryContact"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "employer"
                    }
                },
                "sponsoredCases": {
                    "name": "sponsoredCases",
                    "isArray": true,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "sponsoringEmployer"
                    }
                },
                "contributorCases": {
                    "name": "contributorCases",
                    "isArray": true,
                    "type": {
                        "model": "CaseContributor"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "contributorEmployer"
                    }
                },
                "processRequestAssignments": {
                    "name": "processRequestAssignments",
                    "isArray": true,
                    "type": {
                        "model": "ProcessRequest"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "assignedToEmployer"
                    }
                },
                "hasCompletedOnboardingQuestions": {
                    "name": "hasCompletedOnboardingQuestions",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "recentlyViewedCases": {
                    "name": "recentlyViewedCases",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "mostRecentlyInvited": {
                    "name": "mostRecentlyInvited",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "archived": {
                    "name": "archived",
                    "isArray": false,
                    "type": {
                        "enum": "ArchivedState"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "loginStatus": {
                    "name": "loginStatus",
                    "isArray": false,
                    "type": {
                        "nonModel": "LoginStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "invoicingContactCompanyIDs": {
                    "name": "invoicingContactCompanyIDs",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "isInvoicingContact": {
                    "name": "isInvoicingContact",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "primaryContactCompanyIDs": {
                    "name": "primaryContactCompanyIDs",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "isPrimaryContact": {
                    "name": "isPrimaryContact",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "seniorContactCompanyIDs": {
                    "name": "seniorContactCompanyIDs",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "isSeniorContact": {
                    "name": "isSeniorContact",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "signatoryContactCompanyIDs": {
                    "name": "signatoryContactCompanyIDs",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "isSignatoryContact": {
                    "name": "isSignatoryContact",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "assignedCaseIDs": {
                    "name": "assignedCaseIDs",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "nationalsWithOpenCases": {
                    "name": "nationalsWithOpenCases",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                }
            },
            "syncable": true,
            "pluralName": "Employers",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "searchable",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "bySlug",
                        "fields": [
                            "slug"
                        ],
                        "queryField": "employersBySlug"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byEmail",
                        "fields": [
                            "email"
                        ],
                        "queryField": "employersByEmail"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "alpha",
                        "fields": [
                            "type",
                            "archived",
                            "lowerFull"
                        ],
                        "queryField": "listEmployersAlpha"
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "id",
                                "allow": "owner",
                                "identityClaim": "custom:person_id",
                                "operations": [
                                    "read",
                                    "update"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_id",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyIDs",
                                "operations": [
                                    "read"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyIDs",
                                "operations": [
                                    "read",
                                    "update"
                                ],
                                "groupField": "groups"
                            }
                        ]
                    }
                }
            ]
        },
        "EmployerAssignment": {
            "name": "EmployerAssignment",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "company": {
                    "name": "company",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyID"
                    }
                },
                "employer": {
                    "name": "employer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "employerID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "EmployerAssignments",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "employerID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byEmployer",
                        "fields": [
                            "employerID",
                            "companyID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "allow": "private",
                                "operations": [
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Company": {
            "name": "Company",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "lowerName": {
                    "name": "lowerName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lowerNameKey": {
                    "name": "lowerNameKey",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "slug": {
                    "name": "slug",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "CompanyType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "logo": {
                    "name": "logo",
                    "isArray": false,
                    "type": {
                        "nonModel": "Picture"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "domainWhitelist": {
                    "name": "domainWhitelist",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "isPartnerCompany": {
                    "name": "isPartnerCompany",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isParent": {
                    "name": "isParent",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "children": {
                    "name": "children",
                    "isArray": true,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "parent"
                    }
                },
                "parent": {
                    "name": "parent",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "parentID"
                    }
                },
                "archived": {
                    "name": "archived",
                    "isArray": false,
                    "type": {
                        "enum": "ArchivedState"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "companyNumber": {
                    "name": "companyNumber",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": true,
                    "attributes": []
                },
                "nationalCount": {
                    "name": "nationalCount",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": true,
                    "attributes": []
                },
                "foreignNationals": {
                    "name": "foreignNationals",
                    "isArray": true,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "company"
                    }
                },
                "assignedAttorneys": {
                    "name": "assignedAttorneys",
                    "isArray": true,
                    "type": {
                        "model": "AttorneyAssignment"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "company"
                    }
                },
                "assignedParalegals": {
                    "name": "assignedParalegals",
                    "isArray": true,
                    "type": {
                        "model": "ParalegalAssignment"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "company"
                    }
                },
                "accountManager": {
                    "name": "accountManager",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "accountManagerID"
                    }
                },
                "assignedEmployers": {
                    "name": "assignedEmployers",
                    "isArray": true,
                    "type": {
                        "model": "EmployerAssignment"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "company"
                    }
                },
                "assignedEmployerAdmins": {
                    "name": "assignedEmployerAdmins",
                    "isArray": true,
                    "type": {
                        "model": "EmployerAdminAssignment"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "company"
                    }
                },
                "invoicingContacts": {
                    "name": "invoicingContacts",
                    "isArray": true,
                    "type": {
                        "model": "InvoicingContact"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "company"
                    }
                },
                "primaryContacts": {
                    "name": "primaryContacts",
                    "isArray": true,
                    "type": {
                        "model": "PrimaryContact"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "company"
                    }
                },
                "seniorContacts": {
                    "name": "seniorContacts",
                    "isArray": true,
                    "type": {
                        "model": "SeniorContact"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "company"
                    }
                },
                "signatoryContacts": {
                    "name": "signatoryContacts",
                    "isArray": true,
                    "type": {
                        "model": "SignatoryContact"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "company"
                    }
                },
                "data": {
                    "name": "data",
                    "isArray": false,
                    "type": {
                        "model": "CompanyData"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyDataId"
                    }
                },
                "processRequests": {
                    "name": "processRequests",
                    "isArray": true,
                    "type": {
                        "model": "ProcessRequest"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "company"
                    }
                },
                "jobDescriptions": {
                    "name": "jobDescriptions",
                    "isArray": true,
                    "type": {
                        "model": "JobDescription"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "companyID"
                    }
                },
                "files": {
                    "name": "files",
                    "isArray": true,
                    "type": {
                        "model": "FileData"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "companyID"
                    }
                },
                "fileRequirements": {
                    "name": "fileRequirements",
                    "isArray": true,
                    "type": {
                        "nonModel": "FileRequirement"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "cases": {
                    "name": "cases",
                    "isArray": true,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "company"
                    }
                },
                "openCaseCount": {
                    "name": "openCaseCount",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "closedCaseCount": {
                    "name": "closedCaseCount",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "completedCaseCount": {
                    "name": "completedCaseCount",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "legalTeamIDs": {
                    "name": "legalTeamIDs",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                }
            },
            "syncable": true,
            "pluralName": "Companies",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "queries": {
                            "get": "getCompany",
                            "list": "listCompanies"
                        },
                        "subscriptions": null
                    }
                },
                {
                    "type": "searchable",
                    "properties": {
                        "queries": {
                            "search": "searchCompanies"
                        }
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "companiesByParent",
                        "fields": [
                            "parentID",
                            "archived",
                            "lowerNameKey"
                        ],
                        "queryField": "companiesByParent"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "companiesBySlug",
                        "fields": [
                            "slug"
                        ],
                        "queryField": "companiesBySlug"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "alpha",
                        "fields": [
                            "type",
                            "archived",
                            "lowerNameKey"
                        ],
                        "queryField": "listCompaniesAlpha"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byAccountManager",
                        "fields": [
                            "accountManagerID",
                            "archived",
                            "lowerNameKey"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_admin",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "id",
                                "operations": [
                                    "read",
                                    "update"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "id",
                                "operations": [
                                    "read"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "id",
                                "allow": "owner",
                                "identityClaim": "custom:company_id",
                                "operations": [
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "provider": "apiKey",
                                "operations": [
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "ForeignNational": {
            "name": "ForeignNational",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "PersonType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "slug": {
                    "name": "slug",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "hasLoggedIn": {
                    "name": "hasLoggedIn",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "onboardingSections": {
                    "name": "onboardingSections",
                    "isArray": false,
                    "type": {
                        "nonModel": "NationalOnboardingSections"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "email": {
                    "name": "email",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "emailPersonal": {
                    "name": "emailPersonal",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "emailWork": {
                    "name": "emailWork",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "usMailingAddress": {
                    "name": "usMailingAddress",
                    "isArray": false,
                    "type": {
                        "nonModel": "StreetAddress"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "usResidentialAddress": {
                    "name": "usResidentialAddress",
                    "isArray": false,
                    "type": {
                        "nonModel": "StreetAddress"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "lastAddressOutsideUS": {
                    "name": "lastAddressOutsideUS",
                    "isArray": false,
                    "type": {
                        "nonModel": "StreetAddress"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "username": {
                    "name": "username",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "avatar": {
                    "name": "avatar",
                    "isArray": false,
                    "type": {
                        "nonModel": "Picture"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "firstname": {
                    "name": "firstname",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "middlename": {
                    "name": "middlename",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastname": {
                    "name": "lastname",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "nickname": {
                    "name": "nickname",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "additionalFirstnames": {
                    "name": "additionalFirstnames",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "additionalMiddlenames": {
                    "name": "additionalMiddlenames",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "additionalLastnames": {
                    "name": "additionalLastnames",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "lowerFirst": {
                    "name": "lowerFirst",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "lowerLast": {
                    "name": "lowerLast",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "lowerFull": {
                    "name": "lowerFull",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "maritalStatus": {
                    "name": "maritalStatus",
                    "isArray": false,
                    "type": {
                        "enum": "MaritalStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "spouse": {
                    "name": "spouse",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "dependents": {
                    "name": "dependents",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "phone": {
                    "name": "phone",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "phoneWork": {
                    "name": "phoneWork",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "company": {
                    "name": "company",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyID"
                    }
                },
                "companyNationalNumber": {
                    "name": "companyNationalNumber",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "mostRecentlyInvited": {
                    "name": "mostRecentlyInvited",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "archived": {
                    "name": "archived",
                    "isArray": false,
                    "type": {
                        "enum": "ArchivedState"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "workLocation": {
                    "name": "workLocation",
                    "isArray": false,
                    "type": {
                        "nonModel": "StreetAddress"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "relativesAsSource": {
                    "name": "relativesAsSource",
                    "isArray": true,
                    "type": {
                        "model": "FamilyRelationship"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "source"
                    }
                },
                "relativesAsTarget": {
                    "name": "relativesAsTarget",
                    "isArray": true,
                    "type": {
                        "model": "FamilyRelationship"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "target"
                    }
                },
                "relatives": {
                    "name": "relatives",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "relativeAdmins": {
                    "name": "relativeAdmins",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "immigrationStatus": {
                    "name": "immigrationStatus",
                    "isArray": false,
                    "type": {
                        "nonModel": "ImmigrationStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "visaExpiration": {
                    "name": "visaExpiration",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "nonImmigrantVisaNumber": {
                    "name": "nonImmigrantVisaNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "visaIssueDate": {
                    "name": "visaIssueDate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "visaConsulate": {
                    "name": "visaConsulate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "immigrantVisaApplicant": {
                    "name": "immigrantVisaApplicant",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "immigrantPetitionEverFiled": {
                    "name": "immigrantPetitionEverFiled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "j1j2": {
                    "name": "j1j2",
                    "isArray": false,
                    "type": {
                        "nonModel": "J1J2"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "hasHadI485Filed": {
                    "name": "hasHadI485Filed",
                    "isArray": false,
                    "type": {
                        "nonModel": "BooleanTwoPart"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "hasPendingETA9089": {
                    "name": "hasPendingETA9089",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasApprovedI140": {
                    "name": "hasApprovedI140",
                    "isArray": false,
                    "type": {
                        "nonModel": "I140"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "hasValidOrExpiredEAD": {
                    "name": "hasValidOrExpiredEAD",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasPendingUSCISApplication": {
                    "name": "hasPendingUSCISApplication",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasHadVisaPetitionRevokedOrDenied": {
                    "name": "hasHadVisaPetitionRevokedOrDenied",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasBeenArrestedSinceLastUSEntry": {
                    "name": "hasBeenArrestedSinceLastUSEntry",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "criminalHistory": {
                    "name": "criminalHistory",
                    "isArray": false,
                    "type": {
                        "nonModel": "CriminalHistory"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "hasTransportedWeapons": {
                    "name": "hasTransportedWeapons",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasParticipatedInArmedGroup": {
                    "name": "hasParticipatedInArmedGroup",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasDetailedPerson": {
                    "name": "hasDetailedPerson",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasUsedWeapons": {
                    "name": "hasUsedWeapons",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasWeaponsTraining": {
                    "name": "hasWeaponsTraining",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasCriminalOffence": {
                    "name": "hasCriminalOffence",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasViolatedVisaTerms": {
                    "name": "hasViolatedVisaTerms",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isInRemovalProceedings": {
                    "name": "isInRemovalProceedings",
                    "isArray": false,
                    "type": {
                        "nonModel": "BooleanExplain"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "hasBeenEmployedSinceLastAdmitted": {
                    "name": "hasBeenEmployedSinceLastAdmitted",
                    "isArray": false,
                    "type": {
                        "nonModel": "BooleanExplain"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "citizenshipCountry": {
                    "name": "citizenshipCountry",
                    "isArray": true,
                    "type": {
                        "enum": "CountryCode"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "birthCountry": {
                    "name": "birthCountry",
                    "isArray": false,
                    "type": {
                        "enum": "CountryCode"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "birthState": {
                    "name": "birthState",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "birthDate": {
                    "name": "birthDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "jobDescriptionID": {
                    "name": "jobDescriptionID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "jobDescription": {
                    "name": "jobDescription",
                    "isArray": false,
                    "type": {
                        "model": "JobDescription"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "HAS_ONE",
                        "associatedWith": "id"
                    }
                },
                "nivMaxout": {
                    "name": "nivMaxout",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "offeredSalary": {
                    "name": "offeredSalary",
                    "isArray": false,
                    "type": {
                        "nonModel": "Money"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "isRemote": {
                    "name": "isRemote",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "loginStatus": {
                    "name": "loginStatus",
                    "isArray": false,
                    "type": {
                        "nonModel": "LoginStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "hasNonUSPassport": {
                    "name": "hasNonUSPassport",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "passportGender": {
                    "name": "passportGender",
                    "isArray": false,
                    "type": {
                        "enum": "PassportGender"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "passportIssueDate": {
                    "name": "passportIssueDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "passportExpirationDate": {
                    "name": "passportExpirationDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "passportNumber": {
                    "name": "passportNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "passportCountry": {
                    "name": "passportCountry",
                    "isArray": false,
                    "type": {
                        "enum": "CountryCode"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "usSSN": {
                    "name": "usSSN",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "aNumber": {
                    "name": "aNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastEntryUS": {
                    "name": "lastEntryUS",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "i94ArrivalDepartureRecordNumber": {
                    "name": "i94ArrivalDepartureRecordNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sevisNumber": {
                    "name": "sevisNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "eadNumber": {
                    "name": "eadNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "cases": {
                    "name": "cases",
                    "isArray": true,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "foreignNational"
                    }
                },
                "sponsoredCases": {
                    "name": "sponsoredCases",
                    "isArray": true,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "sponsoringNational"
                    }
                },
                "processRequests": {
                    "name": "processRequests",
                    "isArray": true,
                    "type": {
                        "model": "ProcessRequest"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "foreignNational"
                    }
                },
                "files": {
                    "name": "files",
                    "isArray": true,
                    "type": {
                        "model": "FileData"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "ownerNationalID"
                    }
                },
                "fileRequirements": {
                    "name": "fileRequirements",
                    "isArray": true,
                    "type": {
                        "nonModel": "FileRequirement"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "legalTeamIDs": {
                    "name": "legalTeamIDs",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                }
            },
            "syncable": true,
            "pluralName": "ForeignNationals",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "searchable",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "bySlug",
                        "fields": [
                            "slug"
                        ],
                        "queryField": "nationalsBySlug"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byEmail",
                        "fields": [
                            "email"
                        ],
                        "queryField": "nationalsByEmail"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "archived",
                            "lowerFull"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "alpha",
                        "fields": [
                            "type",
                            "archived",
                            "lowerFull"
                        ],
                        "queryField": "listForeignNationalsAlpha"
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "id",
                                "allow": "owner",
                                "identityClaim": "custom:person_id",
                                "operations": [
                                    "read",
                                    "update"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "update"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "relatives",
                                "allow": "owner",
                                "operations": [
                                    "read"
                                ],
                                "identityClaim": "custom:person_id"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "relativeAdmins",
                                "allow": "owner",
                                "operations": [
                                    "read",
                                    "update"
                                ],
                                "identityClaim": "custom:person_id"
                            }
                        ]
                    }
                }
            ]
        },
        "FamilyRelationship": {
            "name": "FamilyRelationship",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "source": {
                    "name": "source",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "sourceID"
                    }
                },
                "target": {
                    "name": "target",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "targetID"
                    }
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "FamilyRelationshipType"
                    },
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "FamilyRelationships",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "queries": null,
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "bySource",
                        "fields": [
                            "sourceID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byTarget",
                        "fields": [
                            "targetID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "allow": "private",
                                "operations": [
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "JobDescription": {
            "name": "JobDescription",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "companyID": {
                    "name": "companyID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "archived": {
                    "name": "archived",
                    "isArray": false,
                    "type": {
                        "enum": "ArchivedState"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "JobDescriptionType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "foreignNationalID": {
                    "name": "foreignNationalID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "title": {
                    "name": "title",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "officialTitle": {
                    "name": "officialTitle",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "degrees": {
                    "name": "degrees",
                    "isArray": true,
                    "type": {
                        "enum": "Degree"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "requiresBachelors": {
                    "name": "requiresBachelors",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "requiresMasters": {
                    "name": "requiresMasters",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "requiresPhd": {
                    "name": "requiresPhd",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "dotNumber": {
                    "name": "dotNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "caseSocCode": {
                    "name": "caseSocCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "duties": {
                    "name": "duties",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "jobURL": {
                    "name": "jobURL",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "majors": {
                    "name": "majors",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "specialRequirements": {
                    "name": "specialRequirements",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "yearsGeneralExperience": {
                    "name": "yearsGeneralExperience",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "objectiveSkillSetsRequired": {
                    "name": "objectiveSkillSetsRequired",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "offeredSalary": {
                    "name": "offeredSalary",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "certificationLicenses": {
                    "name": "certificationLicenses",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "travelIsRequired": {
                    "name": "travelIsRequired",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "travelPercentage": {
                    "name": "travelPercentage",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "travelDomestic": {
                    "name": "travelDomestic",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "travelInternational": {
                    "name": "travelInternational",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "supervisesOthers": {
                    "name": "supervisesOthers",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "supervisesOthersCount": {
                    "name": "supervisesOthersCount",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "supervisesTitles": {
                    "name": "supervisesTitles",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "supervisorTitle": {
                    "name": "supervisorTitle",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "canWorkFromHome": {
                    "name": "canWorkFromHome",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "uploadedDescription": {
                    "name": "uploadedDescription",
                    "isArray": false,
                    "type": {
                        "model": "FileData"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "uploadedDescriptionID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "JobDescriptions",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byTitle",
                        "fields": [
                            "companyID",
                            "title"
                        ],
                        "queryField": "jobsByCompanyTitle"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "archived",
                            "type"
                        ],
                        "queryField": "jobsByCompany"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byForeignNational",
                        "fields": [
                            "foreignNationalID",
                            "archived",
                            "type"
                        ],
                        "queryField": "listJobsByForeignNational"
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "foreignNationalID",
                                "allow": "owner",
                                "identityClaim": "custom:person_id",
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "allow": "private",
                                "operations": [
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "FileData": {
            "name": "FileData",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "expirationDate": {
                    "name": "expirationDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "fileName": {
                    "name": "fileName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "original": {
                    "name": "original",
                    "isArray": false,
                    "type": {
                        "nonModel": "S3Object"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "fileType": {
                    "name": "fileType",
                    "isArray": false,
                    "type": {
                        "enum": "FileType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "contentType": {
                    "name": "contentType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "processRequestID": {
                    "name": "processRequestID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "companyID": {
                    "name": "companyID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "ownerNationalID": {
                    "name": "ownerNationalID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "sourceID": {
                    "name": "sourceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "uploadDate": {
                    "name": "uploadDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "uploaderForeignNational": {
                    "name": "uploaderForeignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "uploaderID"
                    }
                },
                "uploaderTeamMember": {
                    "name": "uploaderTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "uploaderID"
                    }
                },
                "uploaderEmployer": {
                    "name": "uploaderEmployer",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "uploaderID"
                    }
                },
                "cases": {
                    "name": "cases",
                    "isArray": true,
                    "type": {
                        "model": "CaseFile"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "file"
                    }
                }
            },
            "syncable": true,
            "pluralName": "FileData",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "queries": null,
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byNational",
                        "fields": [
                            "ownerNationalID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byProcessRequest",
                        "fields": [
                            "processRequestID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "bySource",
                        "fields": [
                            "sourceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "read",
                                    "delete"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "TeamMember": {
            "name": "TeamMember",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "slug": {
                    "name": "slug",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "hasLoggedIn": {
                    "name": "hasLoggedIn",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "PersonType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "email": {
                    "name": "email",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "username": {
                    "name": "username",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "avatar": {
                    "name": "avatar",
                    "isArray": false,
                    "type": {
                        "nonModel": "Picture"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "firstname": {
                    "name": "firstname",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "middlename": {
                    "name": "middlename",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastname": {
                    "name": "lastname",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "lowerFirst": {
                    "name": "lowerFirst",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "lowerLast": {
                    "name": "lowerLast",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "lowerFull": {
                    "name": "lowerFull",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "phone": {
                    "name": "phone",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "position": {
                    "name": "position",
                    "isArray": false,
                    "type": {
                        "enum": "Position"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "title": {
                    "name": "title",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "licensingAuthority": {
                    "name": "licensingAuthority",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "stateBarNumber": {
                    "name": "stateBarNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isAdmin": {
                    "name": "isAdmin",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "manager": {
                    "name": "manager",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "managerID"
                    }
                },
                "attorneyAssignments": {
                    "name": "attorneyAssignments",
                    "isArray": true,
                    "type": {
                        "model": "AttorneyAssignment"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "attorney"
                    }
                },
                "paralegalAssignments": {
                    "name": "paralegalAssignments",
                    "isArray": true,
                    "type": {
                        "model": "ParalegalAssignment"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "paralegal"
                    }
                },
                "accountManagerAssignments": {
                    "name": "accountManagerAssignments",
                    "isArray": true,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "accountManager"
                    }
                },
                "attorneyCases": {
                    "name": "attorneyCases",
                    "isArray": true,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "attorney"
                    }
                },
                "caseManagerCases": {
                    "name": "caseManagerCases",
                    "isArray": true,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "caseManager"
                    }
                },
                "contributorCases": {
                    "name": "contributorCases",
                    "isArray": true,
                    "type": {
                        "model": "CaseContributor"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "contributorEmployer"
                    }
                },
                "processRequestAssignments": {
                    "name": "processRequestAssignments",
                    "isArray": true,
                    "type": {
                        "model": "ProcessRequest"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "assignedToEmployer"
                    }
                },
                "mostRecentlyInvited": {
                    "name": "mostRecentlyInvited",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "archived": {
                    "name": "archived",
                    "isArray": false,
                    "type": {
                        "enum": "ArchivedState"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "loginStatus": {
                    "name": "loginStatus",
                    "isArray": false,
                    "type": {
                        "nonModel": "LoginStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "recentlyViewedCases": {
                    "name": "recentlyViewedCases",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "nationalsWithOpenCases": {
                    "name": "nationalsWithOpenCases",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "companiesAssignedTo": {
                    "name": "companiesAssignedTo",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                }
            },
            "syncable": true,
            "pluralName": "TeamMembers",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "searchable",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "bySlug",
                        "fields": [
                            "slug"
                        ],
                        "queryField": "teamBySlug"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byEmail",
                        "fields": [
                            "email"
                        ],
                        "queryField": "teamByEmail"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "alpha",
                        "fields": [
                            "type",
                            "archived",
                            "lowerFull"
                        ],
                        "queryField": "listTeamMembersAlpha"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byPosition",
                        "fields": [
                            "position",
                            "archived",
                            "lowerFull"
                        ],
                        "queryField": "listTeamMembersByPosition"
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "allow": "private",
                                "operations": [
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "provider": "apiKey",
                                "operations": [
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "AttorneyAssignment": {
            "name": "AttorneyAssignment",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "company": {
                    "name": "company",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyID"
                    }
                },
                "attorney": {
                    "name": "attorney",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "attorneyID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "AttorneyAssignments",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "attorneyID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byAttorney",
                        "fields": [
                            "attorneyID",
                            "companyID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "companyID",
                                "allow": "owner",
                                "identityClaim": "custom:company_id",
                                "operations": [
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "provider": "apiKey",
                                "operations": [
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "ParalegalAssignment": {
            "name": "ParalegalAssignment",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "company": {
                    "name": "company",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyID"
                    }
                },
                "paralegal": {
                    "name": "paralegal",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "paralegalID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "ParalegalAssignments",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "paralegalID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byParalegal",
                        "fields": [
                            "paralegalID",
                            "companyID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "companyID",
                                "allow": "owner",
                                "identityClaim": "custom:company_id",
                                "operations": [
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "provider": "apiKey",
                                "operations": [
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Case": {
            "name": "Case",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "caseNumber": {
                    "name": "caseNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "slug": {
                    "name": "slug",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "attorney": {
                    "name": "attorney",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "attorneyID"
                    }
                },
                "caseManager": {
                    "name": "caseManager",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "caseManagerID"
                    }
                },
                "caseNotes": {
                    "name": "caseNotes",
                    "isArray": true,
                    "type": {
                        "model": "CaseNote"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "caseID"
                    }
                },
                "pinnedCaseNoteID": {
                    "name": "pinnedCaseNoteID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "contributors": {
                    "name": "contributors",
                    "isArray": true,
                    "type": {
                        "model": "CaseContributor"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "case"
                    }
                },
                "sponsoringEmployer": {
                    "name": "sponsoringEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "sponsoringEmployerID"
                    }
                },
                "sponsoringNational": {
                    "name": "sponsoringNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "sponsoringNationalID"
                    }
                },
                "foreignNational": {
                    "name": "foreignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "foreignNationalID"
                    }
                },
                "nationalVisaExpiration": {
                    "name": "nationalVisaExpiration",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "relativeAdmins": {
                    "name": "relativeAdmins",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "startDate": {
                    "name": "startDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "closeDate": {
                    "name": "closeDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "closeReason": {
                    "name": "closeReason",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "completeDate": {
                    "name": "completeDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "source": {
                    "name": "source",
                    "isArray": false,
                    "type": {
                        "model": "ProcessRequest"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "sourceID"
                    }
                },
                "state": {
                    "name": "state",
                    "isArray": false,
                    "type": {
                        "enum": "CaseState"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "tasks": {
                    "name": "tasks",
                    "isArray": true,
                    "type": {
                        "model": "Task"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "caseID"
                    }
                },
                "lowerNationalName": {
                    "name": "lowerNationalName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lowerCompanyName": {
                    "name": "lowerCompanyName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lowerProcessType": {
                    "name": "lowerProcessType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "fileRequirements": {
                    "name": "fileRequirements",
                    "isArray": true,
                    "type": {
                        "nonModel": "FileRequirement"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "phaseRequirements": {
                    "name": "phaseRequirements",
                    "isArray": true,
                    "type": {
                        "nonModel": "CasePhaseRequirement"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "completedMilestones": {
                    "name": "completedMilestones",
                    "isArray": true,
                    "type": {
                        "nonModel": "CompletedCaseMilestone"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "files": {
                    "name": "files",
                    "isArray": true,
                    "type": {
                        "model": "CaseFile"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "case"
                    }
                },
                "preparedForms": {
                    "name": "preparedForms",
                    "isArray": true,
                    "type": {
                        "model": "PreparedForm"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "case"
                    }
                },
                "company": {
                    "name": "company",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyID"
                    }
                },
                "individualSponsored": {
                    "name": "individualSponsored",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "jobDescriptionID": {
                    "name": "jobDescriptionID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "jobDescription": {
                    "name": "jobDescription",
                    "isArray": false,
                    "type": {
                        "model": "JobDescription"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "HAS_ONE",
                        "associatedWith": "id"
                    }
                },
                "employeeData": {
                    "name": "employeeData",
                    "isArray": false,
                    "type": {
                        "nonModel": "ProcessRequestEmployeeData"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "employmentData": {
                    "name": "employmentData",
                    "isArray": false,
                    "type": {
                        "nonModel": "ProcessRequestEmploymentData"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "resume": {
                    "name": "resume",
                    "isArray": false,
                    "type": {
                        "model": "FileData"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "resumeID"
                    }
                },
                "requestedProcess": {
                    "name": "requestedProcess",
                    "isArray": false,
                    "type": {
                        "enum": "VisaStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "requestedProcessSubCategory": {
                    "name": "requestedProcessSubCategory",
                    "isArray": false,
                    "type": {
                        "enum": "VisaSubCategory"
                    },
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "Cases",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "searchable",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byAttorney",
                        "fields": [
                            "attorneyID",
                            "state",
                            "startDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCaseManager",
                        "fields": [
                            "caseManagerID",
                            "state",
                            "startDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "state",
                            "startDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byForeignNational",
                        "fields": [
                            "foreignNationalID",
                            "state",
                            "startDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "bySponsorEmployer",
                        "fields": [
                            "sponsoringEmployerID",
                            "state",
                            "startDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "bySponsorNational",
                        "fields": [
                            "sponsoringNationalID",
                            "state",
                            "startDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "caseBySlug",
                        "fields": [
                            "slug"
                        ],
                        "queryField": "caseBySlug"
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "foreignNationalID",
                                "allow": "owner",
                                "operations": [
                                    "read"
                                ],
                                "identityClaim": "custom:person_id"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "sponsoringNationalID",
                                "allow": "owner",
                                "operations": [
                                    "read"
                                ],
                                "identityClaim": "custom:person_id"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "relativeAdmins",
                                "allow": "owner",
                                "operations": [
                                    "read"
                                ],
                                "identityClaim": "custom:person_id"
                            },
                            {
                                "allow": "public",
                                "provider": "apiKey",
                                "operations": [
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "CaseContributor": {
            "name": "CaseContributor",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "case": {
                    "name": "case",
                    "isArray": false,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "caseID"
                    }
                },
                "contributorEmployer": {
                    "name": "contributorEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "contributorID"
                    }
                },
                "contributorForeignNational": {
                    "name": "contributorForeignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "contributorID"
                    }
                },
                "contributorTeamMember": {
                    "name": "contributorTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "contributorID"
                    }
                },
                "foreignNational": {
                    "name": "foreignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "foreignNationalID"
                    }
                },
                "state": {
                    "name": "state",
                    "isArray": false,
                    "type": {
                        "enum": "CaseState"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "PersonType"
                    },
                    "isRequired": true,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "CaseContributors",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "queries": null,
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCase",
                        "fields": [
                            "caseID",
                            "contributorID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byContributor",
                        "fields": [
                            "contributorID",
                            "state",
                            "caseID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "delete"
                                ]
                            },
                            {
                                "allow": "private",
                                "operations": [
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "provider": "apiKey",
                                "operations": [
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "ProcessRequest": {
            "name": "ProcessRequest",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "assignedToEmployer": {
                    "name": "assignedToEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "assignedToID"
                    }
                },
                "assignedToTeamMember": {
                    "name": "assignedToTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "assignedToID"
                    }
                },
                "caseNotes": {
                    "name": "caseNotes",
                    "isArray": true,
                    "type": {
                        "model": "CaseNote"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "processRequestID"
                    }
                },
                "company": {
                    "name": "company",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyID"
                    }
                },
                "files": {
                    "name": "files",
                    "isArray": true,
                    "type": {
                        "model": "FileData"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "processRequestID"
                    }
                },
                "individualSponsored": {
                    "name": "individualSponsored",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "initiator": {
                    "name": "initiator",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "initiatorID"
                    }
                },
                "jobDescriptionID": {
                    "name": "jobDescriptionID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "jobDescription": {
                    "name": "jobDescription",
                    "isArray": false,
                    "type": {
                        "model": "JobDescription"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "HAS_ONE",
                        "associatedWith": "id"
                    }
                },
                "requester": {
                    "name": "requester",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "requesterID"
                    }
                },
                "requestDate": {
                    "name": "requestDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "approvalDate": {
                    "name": "approvalDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "archivedDate": {
                    "name": "archivedDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "cancelDate": {
                    "name": "cancelDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "foreignNational": {
                    "name": "foreignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "foreignNationalID"
                    }
                },
                "employeeData": {
                    "name": "employeeData",
                    "isArray": false,
                    "type": {
                        "nonModel": "ProcessRequestEmployeeData"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "employmentData": {
                    "name": "employmentData",
                    "isArray": false,
                    "type": {
                        "nonModel": "ProcessRequestEmploymentData"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "needsEmployerRevision": {
                    "name": "needsEmployerRevision",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "resume": {
                    "name": "resume",
                    "isArray": false,
                    "type": {
                        "model": "FileData"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "resumeID"
                    }
                },
                "requestedProcess": {
                    "name": "requestedProcess",
                    "isArray": false,
                    "type": {
                        "enum": "VisaStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "requestedProcessSubCategory": {
                    "name": "requestedProcessSubCategory",
                    "isArray": false,
                    "type": {
                        "enum": "VisaSubCategory"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "slug": {
                    "name": "slug",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "state": {
                    "name": "state",
                    "isArray": false,
                    "type": {
                        "enum": "ProcessRequestState"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "lowerNationalName": {
                    "name": "lowerNationalName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lowerCompanyName": {
                    "name": "lowerCompanyName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lowerProcessType": {
                    "name": "lowerProcessType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "ProcessRequests",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "searchable",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "processBySlug",
                        "fields": [
                            "slug"
                        ],
                        "queryField": "processBySlug"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "requestDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byNational",
                        "fields": [
                            "foreignNationalID",
                            "requestDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byEmployer",
                        "fields": [
                            "assignedToID",
                            "state",
                            "requestDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byState",
                        "fields": [
                            "state",
                            "requestDate"
                        ],
                        "queryField": "listProcessesByState"
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Employers"
                                ],
                                "operations": [
                                    "create"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "update"
                                ],
                                "groupField": "groups"
                            }
                        ]
                    }
                }
            ]
        },
        "Task": {
            "name": "Task",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "action": {
                    "name": "action",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "isAssignedToLegalAssistants": {
                    "name": "isAssignedToLegalAssistants",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "assignedToEmployer": {
                    "name": "assignedToEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "assignedToID"
                    }
                },
                "assignedToForeignNational": {
                    "name": "assignedToForeignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "assignedToID"
                    }
                },
                "assignedToTeamMember": {
                    "name": "assignedToTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "assignedToID"
                    }
                },
                "caseID": {
                    "name": "caseID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "category": {
                    "name": "category",
                    "isArray": false,
                    "type": {
                        "enum": "TaskCategory"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "hiddenCategory": {
                    "name": "hiddenCategory",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "comments": {
                    "name": "comments",
                    "isArray": true,
                    "type": {
                        "model": "Comment"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "sourceID"
                    }
                },
                "completeDate": {
                    "name": "completeDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "deadline": {
                    "name": "deadline",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "deadlineIsManuallySet": {
                    "name": "deadlineIsManuallySet",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "deleteDate": {
                    "name": "deleteDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "deleteReason": {
                    "name": "deleteReason",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "dependencies": {
                    "name": "dependencies",
                    "isArray": true,
                    "type": {
                        "model": "Task"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "prerequisite"
                    }
                },
                "duration": {
                    "name": "duration",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "groupsCanRead": {
                    "name": "groupsCanRead",
                    "isArray": true,
                    "type": {
                        "enum": "UserGroup"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "prerequisite": {
                    "name": "prerequisite",
                    "isArray": false,
                    "type": {
                        "model": "Task"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "prerequisiteID"
                    }
                },
                "startDate": {
                    "name": "startDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "state": {
                    "name": "state",
                    "isArray": false,
                    "type": {
                        "enum": "TaskState"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "templateID": {
                    "name": "templateID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "Tasks",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "queries": null,
                        "subscriptions": null
                    }
                },
                {
                    "type": "searchable",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCase",
                        "fields": [
                            "caseID",
                            "state",
                            "deadline"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byPrerequisite",
                        "fields": [
                            "prerequisiteID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byAssignee",
                        "fields": [
                            "assignedToID",
                            "state",
                            "deadline"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "groupsCanRead",
                                "operations": [
                                    "read",
                                    "update"
                                ],
                                "groupField": "groups"
                            }
                        ]
                    }
                }
            ]
        },
        "Comment": {
            "name": "Comment",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "authorEmployer": {
                    "name": "authorEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "authorID"
                    }
                },
                "authorForeignNational": {
                    "name": "authorForeignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "authorID"
                    }
                },
                "authorTeamMember": {
                    "name": "authorTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "authorID"
                    }
                },
                "note": {
                    "name": "note",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sourceID": {
                    "name": "sourceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "Comments",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "queries": null,
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "bySource",
                        "fields": [
                            "sourceID",
                            "createdAt"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "read",
                                    "create"
                                ]
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "owner",
                                "allow": "owner",
                                "operations": [
                                    "read",
                                    "create",
                                    "update"
                                ],
                                "identityClaim": "cognito:username"
                            }
                        ]
                    }
                }
            ]
        },
        "CaseFile": {
            "name": "CaseFile",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "file": {
                    "name": "file",
                    "isArray": false,
                    "type": {
                        "model": "FileData"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "fileID"
                    }
                },
                "case": {
                    "name": "case",
                    "isArray": false,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "caseID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "CaseFiles",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "queries": null,
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCase",
                        "fields": [
                            "caseID",
                            "fileID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byFile",
                        "fields": [
                            "fileID",
                            "caseID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "read",
                                    "delete"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "PreparedForm": {
            "name": "PreparedForm",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "case": {
                    "name": "case",
                    "isArray": false,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "caseID"
                    }
                },
                "companyID": {
                    "name": "companyID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "foreignNational": {
                    "name": "foreignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "foreignNationalID"
                    }
                },
                "relativeAdmins": {
                    "name": "relativeAdmins",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "state": {
                    "name": "state",
                    "isArray": false,
                    "type": {
                        "enum": "PreparedFormState"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "preparer": {
                    "name": "preparer",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "preparerID"
                    }
                },
                "templateID": {
                    "name": "templateID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "template": {
                    "name": "template",
                    "isArray": false,
                    "type": {
                        "nonModel": "PreparedFormTemplate"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "completedForm": {
                    "name": "completedForm",
                    "isArray": false,
                    "type": {
                        "model": "FileData"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "completedFormID"
                    }
                },
                "completedFormHistory": {
                    "name": "completedFormHistory",
                    "isArray": true,
                    "type": {
                        "model": "FileData"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "sourceID"
                    }
                },
                "assignedToEmployer": {
                    "name": "assignedToEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "assignedToID"
                    }
                },
                "assignedToNational": {
                    "name": "assignedToNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "assignedToID"
                    }
                },
                "assignedToTeamMember": {
                    "name": "assignedToTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "assignedToID"
                    }
                },
                "rejectedDate": {
                    "name": "rejectedDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "rejectedByEmployer": {
                    "name": "rejectedByEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "rejectedByID"
                    }
                },
                "rejectedByNational": {
                    "name": "rejectedByNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "rejectedByID"
                    }
                },
                "rejectedByTeamMember": {
                    "name": "rejectedByTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "rejectedByID"
                    }
                },
                "requiresAttorneyApproval": {
                    "name": "requiresAttorneyApproval",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "attorneyApprover": {
                    "name": "attorneyApprover",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "attorneyApproverID"
                    }
                },
                "attorneyApprovalDate": {
                    "name": "attorneyApprovalDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "requiresSponsorApproval": {
                    "name": "requiresSponsorApproval",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "sponsorApproverEmployer": {
                    "name": "sponsorApproverEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "sponsorApproverID"
                    }
                },
                "sponsorApproverNational": {
                    "name": "sponsorApproverNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "sponsorApproverID"
                    }
                },
                "sponsorApprovalDate": {
                    "name": "sponsorApprovalDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "requiresNationalApproval": {
                    "name": "requiresNationalApproval",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "nationalApprover": {
                    "name": "nationalApprover",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "nationalApproverID"
                    }
                },
                "nationalApprovalDate": {
                    "name": "nationalApprovalDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "finalCaseManagerApprover": {
                    "name": "finalCaseManagerApprover",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "finalCaseManagerApproverID"
                    }
                },
                "finalCaseManagerApprovalDate": {
                    "name": "finalCaseManagerApprovalDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "employersCanView": {
                    "name": "employersCanView",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "nationalsCanView": {
                    "name": "nationalsCanView",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "comments": {
                    "name": "comments",
                    "isArray": true,
                    "type": {
                        "model": "Comment"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "sourceID"
                    }
                },
                "activities": {
                    "name": "activities",
                    "isArray": true,
                    "type": {
                        "model": "Activity"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "indirectTargetCase"
                    }
                }
            },
            "syncable": true,
            "pluralName": "PreparedForms",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byForeignNational",
                        "fields": [
                            "foreignNationalID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCase",
                        "fields": [
                            "caseID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byAssignee",
                        "fields": [
                            "assignedToID",
                            "state",
                            "updatedAt"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "update"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "foreignNationalID",
                                "allow": "owner",
                                "operations": [
                                    "read",
                                    "update"
                                ],
                                "identityClaim": "custom:person_id"
                            },
                            {
                                "provider": "userPools",
                                "ownerField": "relativeAdmins",
                                "allow": "owner",
                                "operations": [
                                    "read",
                                    "update"
                                ],
                                "identityClaim": "custom:person_id"
                            }
                        ]
                    }
                }
            ]
        },
        "Activity": {
            "name": "Activity",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "activityType": {
                    "name": "activityType",
                    "isArray": false,
                    "type": {
                        "enum": "ActivityType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "ipAddress": {
                    "name": "ipAddress",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "actorType": {
                    "name": "actorType",
                    "isArray": false,
                    "type": {
                        "enum": "PersonType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "actorEmployer": {
                    "name": "actorEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "actorID"
                    }
                },
                "actorForeignNational": {
                    "name": "actorForeignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "actorID"
                    }
                },
                "actorTeamMember": {
                    "name": "actorTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "actorID"
                    }
                },
                "targetString": {
                    "name": "targetString",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "targetCase": {
                    "name": "targetCase",
                    "isArray": false,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "directTargetID"
                    }
                },
                "targetCompany": {
                    "name": "targetCompany",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "directTargetID"
                    }
                },
                "targetEmployer": {
                    "name": "targetEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "directTargetID"
                    }
                },
                "targetFileData": {
                    "name": "targetFileData",
                    "isArray": false,
                    "type": {
                        "model": "FileData"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "directTargetID"
                    }
                },
                "targetForeignNational": {
                    "name": "targetForeignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "directTargetID"
                    }
                },
                "targetProcessRequest": {
                    "name": "targetProcessRequest",
                    "isArray": false,
                    "type": {
                        "model": "ProcessRequest"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "directTargetID"
                    }
                },
                "targetTeamMember": {
                    "name": "targetTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "directTargetID"
                    }
                },
                "indirectTargetString": {
                    "name": "indirectTargetString",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "indirectTargetCase": {
                    "name": "indirectTargetCase",
                    "isArray": false,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "indirectTargetID"
                    }
                },
                "indirectTargetCompany": {
                    "name": "indirectTargetCompany",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "indirectTargetID"
                    }
                },
                "indirectTargetEmployer": {
                    "name": "indirectTargetEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "indirectTargetID"
                    }
                },
                "indirectTargetForeignNational": {
                    "name": "indirectTargetForeignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "indirectTargetID"
                    }
                },
                "indirectTargetProcessRequest": {
                    "name": "indirectTargetProcessRequest",
                    "isArray": false,
                    "type": {
                        "model": "ProcessRequest"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "indirectTargetID"
                    }
                },
                "indirectTargetTeamMember": {
                    "name": "indirectTargetTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "indirectTargetID"
                    }
                },
                "ownerCase": {
                    "name": "ownerCase",
                    "isArray": false,
                    "type": {
                        "model": "Case"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "ownerID"
                    }
                },
                "ownerCompany": {
                    "name": "ownerCompany",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "ownerID"
                    }
                },
                "ownerEmployer": {
                    "name": "ownerEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "ownerID"
                    }
                },
                "ownerFileData": {
                    "name": "ownerFileData",
                    "isArray": false,
                    "type": {
                        "model": "FileData"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "ownerID"
                    }
                },
                "ownerForeignNational": {
                    "name": "ownerForeignNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "ownerID"
                    }
                },
                "ownerProcessRequest": {
                    "name": "ownerProcessRequest",
                    "isArray": false,
                    "type": {
                        "model": "ProcessRequest"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "ownerID"
                    }
                },
                "ownerTeamMember": {
                    "name": "ownerTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "ownerID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "Activities",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "queries": null,
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byIndirectTargetID",
                        "fields": [
                            "indirectTargetID",
                            "createdAt"
                        ]
                    }
                },
                {
                    "type": "searchable",
                    "properties": {
                        "queries": {
                            "search": "searchActivities"
                        }
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "read",
                                    "delete"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "EmployerAdminAssignment": {
            "name": "EmployerAdminAssignment",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "company": {
                    "name": "company",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyID"
                    }
                },
                "employer": {
                    "name": "employer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "employerID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "EmployerAdminAssignments",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "employerID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byEmployer",
                        "fields": [
                            "employerID",
                            "companyID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "allow": "private",
                                "operations": [
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "InvoicingContact": {
            "name": "InvoicingContact",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "company": {
                    "name": "company",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyID"
                    }
                },
                "employer": {
                    "name": "employer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "employerID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "InvoicingContacts",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "employerID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byEmployer",
                        "fields": [
                            "employerID",
                            "companyID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_admin",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ],
                                "groupField": "groups"
                            }
                        ]
                    }
                }
            ]
        },
        "PrimaryContact": {
            "name": "PrimaryContact",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "company": {
                    "name": "company",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyID"
                    }
                },
                "employer": {
                    "name": "employer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "employerID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "PrimaryContacts",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "employerID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byEmployer",
                        "fields": [
                            "employerID",
                            "companyID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_admin",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ],
                                "groupField": "groups"
                            }
                        ]
                    }
                }
            ]
        },
        "SeniorContact": {
            "name": "SeniorContact",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "company": {
                    "name": "company",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyID"
                    }
                },
                "employer": {
                    "name": "employer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "employerID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "SeniorContacts",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "employerID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byEmployer",
                        "fields": [
                            "employerID",
                            "companyID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_admin",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ],
                                "groupField": "groups"
                            }
                        ]
                    }
                }
            ]
        },
        "SignatoryContact": {
            "name": "SignatoryContact",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "company": {
                    "name": "company",
                    "isArray": false,
                    "type": {
                        "model": "Company"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "companyID"
                    }
                },
                "employer": {
                    "name": "employer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "employerID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "SignatoryContacts",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompany",
                        "fields": [
                            "companyID",
                            "employerID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byEmployer",
                        "fields": [
                            "employerID",
                            "companyID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_admin",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ],
                                "groupField": "groups"
                            }
                        ]
                    }
                }
            ]
        },
        "CompanyData": {
            "name": "CompanyData",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "companyID": {
                    "name": "companyID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "addressPrimary": {
                    "name": "addressPrimary",
                    "isArray": false,
                    "type": {
                        "nonModel": "StreetAddress"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "addressSecondary": {
                    "name": "addressSecondary",
                    "isArray": false,
                    "type": {
                        "nonModel": "StreetAddress"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "allowsEmployeesToTelecommute": {
                    "name": "allowsEmployeesToTelecommute",
                    "isArray": false,
                    "type": {
                        "nonModel": "BooleanThreePart"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "preferredMailingAddress": {
                    "name": "preferredMailingAddress",
                    "isArray": false,
                    "type": {
                        "enum": "CompanyAddressType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "companyCoversExpenseOfDependentPetitionsAndOrEADCards": {
                    "name": "companyCoversExpenseOfDependentPetitionsAndOrEADCards",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "doingBusinessAs": {
                    "name": "doingBusinessAs",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "educationEvaluation": {
                    "name": "educationEvaluation",
                    "isArray": false,
                    "type": {
                        "enum": "EducationEvaluation"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "employeesEmailMHAttorneysAndParalegalsDirectly": {
                    "name": "employeesEmailMHAttorneysAndParalegalsDirectly",
                    "isArray": false,
                    "type": {
                        "enum": "EmployeesEmailContactDirectly"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "fein": {
                    "name": "fein",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "fullTimeEmployeesInUS": {
                    "name": "fullTimeEmployeesInUS",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "grossRevenueForMostRecentFiscalYear": {
                    "name": "grossRevenueForMostRecentFiscalYear",
                    "isArray": false,
                    "type": {
                        "nonModel": "Money"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "isH1BDependentEmloyer": {
                    "name": "isH1BDependentEmloyer",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasBeenWillfulViolator": {
                    "name": "hasBeenWillfulViolator",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "employs50OrMore": {
                    "name": "employs50OrMore",
                    "isArray": false,
                    "type": {
                        "nonModel": "BooleanTwoPart"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "isHigherEd_20_USC_1001_a": {
                    "name": "isHigherEd_20_USC_1001_a",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B": {
                    "name": "isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2": {
                    "name": "isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isNonProfitResearch_8_CFR_214_2_h_19_iii_C": {
                    "name": "isNonProfitResearch_8_CFR_214_2_h_19_iii_C",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3": {
                    "name": "isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4": {
                    "name": "isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "maintainsAWrittenImmigrationPolicy": {
                    "name": "maintainsAWrittenImmigrationPolicy",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "naicsCodeOfCompany": {
                    "name": "naicsCodeOfCompany",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "netRevenueForMostRecentFiscalYear": {
                    "name": "netRevenueForMostRecentFiscalYear",
                    "isArray": false,
                    "type": {
                        "nonModel": "Money"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "partTimeEmployeesInUS": {
                    "name": "partTimeEmployeesInUS",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "paymentPreference": {
                    "name": "paymentPreference",
                    "isArray": false,
                    "type": {
                        "enum": "PaymentPreference"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "permissionPowerAttorney": {
                    "name": "permissionPowerAttorney",
                    "isArray": false,
                    "type": {
                        "enum": "CompanyEmployee"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "permissionReleaseApprovalNotices": {
                    "name": "permissionReleaseApprovalNotices",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "permissionReleasePetitionsRFE": {
                    "name": "permissionReleasePetitionsRFE",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "permissionReleaseLCA": {
                    "name": "permissionReleaseLCA",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "permissionRelease9089": {
                    "name": "permissionRelease9089",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "phone": {
                    "name": "phone",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime": {
                    "name": "placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "preferenceForEmployeesToPayPartOfGreenCard": {
                    "name": "preferenceForEmployeesToPayPartOfGreenCard",
                    "isArray": false,
                    "type": {
                        "nonModel": "BooleanExplain"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "preferenceForEmployeesToPayPartOfH1B": {
                    "name": "preferenceForEmployeesToPayPartOfH1B",
                    "isArray": false,
                    "type": {
                        "nonModel": "BooleanExplain"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "fax": {
                    "name": "fax",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "preferredShippingSpeedForDocuments": {
                    "name": "preferredShippingSpeedForDocuments",
                    "isArray": false,
                    "type": {
                        "enum": "PreferredShippingSpeedForDocuments"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "shipOriginalApprovalNotices": {
                    "name": "shipOriginalApprovalNotices",
                    "isArray": false,
                    "type": {
                        "enum": "CompanyEmployee"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "shippingPreference": {
                    "name": "shippingPreference",
                    "isArray": false,
                    "type": {
                        "nonModel": "ShippingPreference"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "staffsEmployeesAtThirdPartyEndClientSites": {
                    "name": "staffsEmployeesAtThirdPartyEndClientSites",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "typeOfBusiness": {
                    "name": "typeOfBusiness",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "usesWageSurvey": {
                    "name": "usesWageSurvey",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "usesApplicantTrackingSystem": {
                    "name": "usesApplicantTrackingSystem",
                    "isArray": false,
                    "type": {
                        "nonModel": "BooleanExplain"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "usesHRSSystem": {
                    "name": "usesHRSSystem",
                    "isArray": false,
                    "type": {
                        "nonModel": "BooleanExplain"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "usesEVerify": {
                    "name": "usesEVerify",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "utilizePremiumProcessingService": {
                    "name": "utilizePremiumProcessingService",
                    "isArray": false,
                    "type": {
                        "enum": "UtilizePremiumProcessingService"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "technologyReleaseLicenseRequirement": {
                    "name": "technologyReleaseLicenseRequirement",
                    "isArray": false,
                    "type": {
                        "enum": "TechnologyReleaseLicenseRequirement"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "yearCompanyWasFoundedInUS": {
                    "name": "yearCompanyWasFoundedInUS",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "CompanyData",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "queries": null,
                        "subscriptions": null
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            },
                            {
                                "groupClaim": "custom:company_admin",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read",
                                    "update"
                                ],
                                "groupField": "groups"
                            },
                            {
                                "groupClaim": "custom:company_access",
                                "provider": "userPools",
                                "allow": "groups",
                                "groupsField": "companyID",
                                "operations": [
                                    "read"
                                ],
                                "groupField": "groups"
                            }
                        ]
                    }
                }
            ]
        },
        "Notification": {
            "name": "Notification",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "activityID": {
                    "name": "activityID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "activity": {
                    "name": "activity",
                    "isArray": false,
                    "type": {
                        "model": "Activity"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "HAS_ONE",
                        "associatedWith": "id"
                    }
                },
                "read": {
                    "name": "read",
                    "isArray": false,
                    "type": {
                        "enum": "ReadState"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "personNational": {
                    "name": "personNational",
                    "isArray": false,
                    "type": {
                        "model": "ForeignNational"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "personID"
                    }
                },
                "personEmployer": {
                    "name": "personEmployer",
                    "isArray": false,
                    "type": {
                        "model": "Employer"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "personID"
                    }
                },
                "personTeamMember": {
                    "name": "personTeamMember",
                    "isArray": false,
                    "type": {
                        "model": "TeamMember"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "association": {
                        "connectionType": "BELONGS_TO",
                        "targetName": "personID"
                    }
                }
            },
            "syncable": true,
            "pluralName": "Notifications",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byPersonByRead",
                        "fields": [
                            "personID",
                            "read",
                            "createdAt"
                        ],
                        "queryField": "listNotificationsByPersonByRead"
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byPersonAll",
                        "fields": [
                            "personID",
                            "createdAt"
                        ],
                        "queryField": "listNotificationsByPersonAll"
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "read",
                                    "delete"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Firm": {
            "name": "Firm",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "slug": {
                    "name": "slug",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "logo": {
                    "name": "logo",
                    "isArray": false,
                    "type": {
                        "nonModel": "Picture"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "domainWhitelist": {
                    "name": "domainWhitelist",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "address": {
                    "name": "address",
                    "isArray": false,
                    "type": {
                        "nonModel": "StreetAddress"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "mailingAddress": {
                    "name": "mailingAddress",
                    "isArray": false,
                    "type": {
                        "nonModel": "StreetAddress"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "doingBusinessAs": {
                    "name": "doingBusinessAs",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "phone": {
                    "name": "phone",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "fax": {
                    "name": "fax",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "knowledgeCenterLinks": {
                    "name": "knowledgeCenterLinks",
                    "isArray": true,
                    "type": {
                        "nonModel": "KnowledgeCenterLink"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "shortcuts": {
                    "name": "shortcuts",
                    "isArray": true,
                    "type": {
                        "nonModel": "Shortcut"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "holidays": {
                    "name": "holidays",
                    "isArray": true,
                    "type": "AWSDate",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "companyCount": {
                    "name": "companyCount",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": true,
                    "attributes": []
                },
                "nationalCount": {
                    "name": "nationalCount",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": true,
                    "attributes": []
                },
                "preparedFormTemplates": {
                    "name": "preparedFormTemplates",
                    "isArray": true,
                    "type": {
                        "nonModel": "PreparedFormTemplate"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                }
            },
            "syncable": true,
            "pluralName": "Firms",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update"
                                ]
                            },
                            {
                                "allow": "private",
                                "operations": [
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "TaskTemplate": {
            "name": "TaskTemplate",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "defaultAssignee": {
                    "name": "defaultAssignee",
                    "isArray": false,
                    "type": {
                        "enum": "TaskAssignmentRole"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "duration": {
                    "name": "duration",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "groupsCanRead": {
                    "name": "groupsCanRead",
                    "isArray": true,
                    "type": {
                        "enum": "UserGroup"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "action": {
                    "name": "action",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "prerequisiteID": {
                    "name": "prerequisiteID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "process": {
                    "name": "process",
                    "isArray": false,
                    "type": {
                        "enum": "VisaStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "category": {
                    "name": "category",
                    "isArray": false,
                    "type": {
                        "enum": "TaskCategory"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "hidden": {
                    "name": "hidden",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "TaskTemplates",
            "attributes": [
                {
                    "type": "model",
                    "properties": {
                        "subscriptions": null
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byProcess",
                        "fields": [
                            "process"
                        ],
                        "queryField": "listTaskTemplatesByProcess"
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins",
                                    "Team"
                                ],
                                "operations": [
                                    "read",
                                    "create",
                                    "update",
                                    "delete"
                                ]
                            }
                        ]
                    }
                }
            ]
        }
    },
    "enums": {
        "UserGroup": {
            "name": "UserGroup",
            "values": [
                "Admins",
                "Employers",
                "GlobalPartners",
                "Nationals",
                "Team"
            ]
        },
        "ArchivedState": {
            "name": "ArchivedState",
            "values": [
                "ACTIVE",
                "ARCHIVED"
            ]
        },
        "S3Level": {
            "name": "S3Level",
            "values": [
                "PRIVATE",
                "PROTECTED",
                "PUBLIC"
            ]
        },
        "UserStatus": {
            "name": "UserStatus",
            "values": [
                "UNCONFIRMED",
                "CONFIRMED",
                "ARCHIVED",
                "COMPROMISED",
                "UNKNOWN",
                "RESET_REQUIRED",
                "FORCE_CHANGE_PASSWORD"
            ]
        },
        "PersonType": {
            "name": "PersonType",
            "values": [
                "Employer",
                "ForeignNational",
                "TeamMember"
            ]
        },
        "CompanyType": {
            "name": "CompanyType",
            "values": [
                "Company"
            ]
        },
        "CompanyAddressType": {
            "name": "CompanyAddressType",
            "values": [
                "HEADQUARTERS",
                "SECONDARY"
            ]
        },
        "UnitType": {
            "name": "UnitType",
            "values": [
                "APARTMENT",
                "SUITE",
                "FLOOR"
            ]
        },
        "StateCode": {
            "name": "StateCode",
            "values": [
                "AL",
                "AK",
                "AZ",
                "AR",
                "CA",
                "CO",
                "CT",
                "DE",
                "DC",
                "FL",
                "GA",
                "HI",
                "ID",
                "IL",
                "IN",
                "IA",
                "KS",
                "KY",
                "LA",
                "ME",
                "MD",
                "MA",
                "MI",
                "MN",
                "MS",
                "MO",
                "MT",
                "NE",
                "NV",
                "NH",
                "NJ",
                "NM",
                "NY",
                "NC",
                "ND",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VT",
                "VA",
                "WA",
                "WV",
                "WI",
                "WY"
            ]
        },
        "CountryCode": {
            "name": "CountryCode",
            "values": [
                "AD",
                "AE",
                "AF",
                "AG",
                "AI",
                "AL",
                "AM",
                "AN",
                "AO",
                "AQ",
                "AR",
                "AS",
                "AT",
                "AU",
                "AW",
                "AX",
                "AZ",
                "BA",
                "BB",
                "BD",
                "BE",
                "BF",
                "BG",
                "BH",
                "BI",
                "BJ",
                "BL",
                "BM",
                "BN",
                "BO",
                "BQ",
                "BR",
                "BS",
                "BT",
                "BV",
                "BW",
                "BY",
                "BZ",
                "CA",
                "CC",
                "CD",
                "CF",
                "CG",
                "CH",
                "CI",
                "CK",
                "CL",
                "CM",
                "CN",
                "CO",
                "CR",
                "CU",
                "CV",
                "CW",
                "CX",
                "CY",
                "CZ",
                "DE",
                "DJ",
                "DK",
                "DM",
                "DO",
                "DZ",
                "EC",
                "EE",
                "EG",
                "EH",
                "ER",
                "ES",
                "ET",
                "EU",
                "FI",
                "FJ",
                "FK",
                "FM",
                "FO",
                "FR",
                "GA",
                "GB",
                "GD",
                "GE",
                "GF",
                "GG",
                "GH",
                "GI",
                "GL",
                "GM",
                "GN",
                "GP",
                "GQ",
                "GR",
                "GS",
                "GT",
                "GU",
                "GW",
                "GY",
                "HK",
                "HM",
                "HN",
                "HR",
                "HT",
                "HU",
                "ID",
                "IE",
                "IL",
                "IM",
                "IN",
                "IO",
                "IQ",
                "IR",
                "IS",
                "IT",
                "JE",
                "JM",
                "JO",
                "JP",
                "KE",
                "KG",
                "KH",
                "KI",
                "KM",
                "KN",
                "KP",
                "KR",
                "KW",
                "KY",
                "KZ",
                "LA",
                "LB",
                "LC",
                "LI",
                "LK",
                "LR",
                "LS",
                "LT",
                "LU",
                "LV",
                "LY",
                "MA",
                "MC",
                "MD",
                "ME",
                "MF",
                "MG",
                "MH",
                "MK",
                "ML",
                "MM",
                "MN",
                "MO",
                "MP",
                "MQ",
                "MR",
                "MS",
                "MT",
                "MU",
                "MV",
                "MW",
                "MX",
                "MY",
                "MZ",
                "NA",
                "NC",
                "NE",
                "NF",
                "NG",
                "NI",
                "NL",
                "NO",
                "NP",
                "NR",
                "NU",
                "NZ",
                "OM",
                "PA",
                "PE",
                "PF",
                "PG",
                "PH",
                "PK",
                "PL",
                "PM",
                "PN",
                "PR",
                "PS",
                "PT",
                "PW",
                "PY",
                "QA",
                "RE",
                "RO",
                "RS",
                "RU",
                "RW",
                "SA",
                "SB",
                "SC",
                "SD",
                "SE",
                "SG",
                "SH",
                "SI",
                "SJ",
                "SK",
                "SL",
                "SM",
                "SN",
                "SO",
                "SR",
                "SS",
                "ST",
                "SV",
                "SX",
                "SY",
                "SZ",
                "TC",
                "TD",
                "TF",
                "TG",
                "TH",
                "TJ",
                "TK",
                "TL",
                "TM",
                "TN",
                "TO",
                "TR",
                "TT",
                "TV",
                "TW",
                "TZ",
                "UA",
                "UG",
                "UM",
                "US",
                "UY",
                "UZ",
                "VA",
                "VI",
                "VC",
                "VE",
                "VG",
                "VN",
                "VU",
                "WF",
                "WS",
                "YE",
                "YT",
                "ZA",
                "ZM",
                "ZW"
            ]
        },
        "MaritalStatus": {
            "name": "MaritalStatus",
            "values": [
                "UNMARRIED",
                "MARRIED",
                "DIVORCED",
                "WIDOWED"
            ]
        },
        "FamilyRelationshipType": {
            "name": "FamilyRelationshipType",
            "values": [
                "AUNT_UNCLE",
                "CHILD",
                "CHILD_IN_LAW",
                "CHILD_OF_GUARDIAN",
                "COMMON_LAW_PARTNER",
                "COUSIN",
                "FIANCE",
                "GRANDCHILD",
                "GRANDPARENT",
                "GUARDIAN",
                "LTDP",
                "NIECE_NEPHEW",
                "PARENT",
                "PARENT_IN_LAW",
                "PRIOR_LTDP",
                "SIBLING",
                "SPOUSE",
                "SPOUSE_DECEASED",
                "SPOUSE_DIVORCED",
                "PRIOR_SPOUSE_OF_DECEASED",
                "STEP_CHILD",
                "STEP_PARENT"
            ]
        },
        "VisaStatus": {
            "name": "VisaStatus",
            "values": [
                "B_1",
                "E_1",
                "E_2",
                "H_1B",
                "H_2A",
                "H_1B1",
                "H_4",
                "E_3",
                "GLOBAL_PROCESS",
                "H_3",
                "I",
                "J_1",
                "L_1",
                "L_1A",
                "L_1B",
                "L_BLANKET",
                "PERM_GREEN_CARD",
                "O_1",
                "P_1",
                "P_3",
                "R_1",
                "TN",
                "NOT_SURE"
            ]
        },
        "EmploymentBasedCategory": {
            "name": "EmploymentBasedCategory",
            "values": [
                "EB_1",
                "EB_2",
                "EB_3",
                "EB_4",
                "EB_5_NON_REGIONAL_CENTER",
                "EB_5_REGIONAL_CENTER",
                "EB_OTHER_WORKERS",
                "EB_CERTAIN_RELIGIOUS_WORKERS",
                "EB_5_SET_ASIDE",
                "SPOUSE_OF_US_CITIZEN",
                "PARENT_OF_US_CITIZEN",
                "F_1",
                "F_2A",
                "F_2B",
                "F_3",
                "F_4",
                "REFUGEE_OR_ASYLEE",
                "DIVERSITY",
                "SPECIAL_IMMIGRANT",
                "HUMAN_TRAFFICKING_AND_CRIME_VICTIM",
                "VICTIM_OF_ABUSE"
            ]
        },
        "JobDescriptionType": {
            "name": "JobDescriptionType",
            "values": [
                "STANDARD",
                "ONEOFF"
            ]
        },
        "Degree": {
            "name": "Degree",
            "values": [
                "NONE",
                "BACHELORS",
                "MASTERS",
                "PHD"
            ]
        },
        "FileType": {
            "name": "FileType",
            "values": [
                "BIRTH_CERTIFICATE",
                "COMPANY_FINANCIAL_STATEMENT",
                "DIPLOMA",
                "EAD_CARD",
                "EDUCATION_EVALUATION",
                "EXPERIENCE_LETTER",
                "H_1B_APPLICATION",
                "H_4_APPLICATION",
                "I_140_APPROVAL_NOTICE",
                "I_20_COPY",
                "I_797_APPROVAL_NOTICE",
                "I_94",
                "JOB_DESCRIPTION",
                "MARKETING_MATERIAL",
                "MARRIAGE_CERTIFICATE",
                "MASTER_AGREEMENT",
                "OTHER",
                "PASSPORT",
                "PASSPORT_PHOTO",
                "PAY_STUBS",
                "PERM_APPLICATION",
                "PERM_SIGNATURE_PAGES",
                "PREVIOUS_I_140_APPROVAL_NOTICES",
                "PREVIOUS_I_797_APPROVAL_NOTICES",
                "PRIOR_EAD",
                "RESUME",
                "COMPLETED_FORMS",
                "SCHOOL_MARK_TRANSCRIPT",
                "SIGNED_EMPLOYMENT_CONTRACT",
                "SUPPORT_LETTER",
                "VENDOR_CLIENT_LETTERS",
                "VISA_STAMPS",
                "W2",
                //Extra Documents
                "H_1B_RECEIPT_NOTICE",
                "H_1B_SIGNATURE_PAGES",
                "H_4_RECEIPT_NOTICE",
                "H_4_SIGNATURE_PAGES",
            ]
        },
        "Position": {
            "name": "Position",
            "values": [
                "ATTORNEY",
                "PARALEGAL",
                "LEGAL_ASSISTANT",
                "CONTRIBUTOR"
            ]
        },
        "CaseState": {
            "name": "CaseState",
            "values": [
                "NA",
                "PENDING",
                "OPEN",
                "CLOSED",
                "COMPLETED"
            ]
        },
        "ProcessRequestLocationType": {
            "name": "ProcessRequestLocationType",
            "values": [
                "HEADQUARTERS",
                "SECONDARY",
                "REMOTE"
            ]
        },
        "Currency": {
            "name": "Currency",
            "values": [
                "USD",
                "EUR",
                "GBP"
            ]
        },
        "VisaSubCategory": {
            "name": "VisaSubCategory",
            "values": [
                "H_1B_CHANGE_STATUS",
                "H_1B_EXTENSION",
                "H_1B_EXTENSION_SUBSEQUENT",
                "H_1B_AMENDMENT",
                "H_1B_TRANSFER",
                "H_1B_CAP_LOTTERY",
                "H_4_CHANGE_STATUS",
                "H_4_EXTENSION",
                "USCIS_PRIMARY_ADVANCE_PAROLE",
                "USCIS_PRIMARY_B_1",
                "USCIS_PRIMARY_EB_1A",
                "USCIS_PRIMARY_EB_1B",
                "USCIS_PRIMARY_EB_1C",
                "USCIS_PRIMARY_E_1",
                "USCIS_PRIMARY_E_2",
                "USCIS_PRIMARY_H_3",
                "USCIS_PRIMARY_I",
                "USCIS_PRIMARY_INTERNATIONAL_ENTREPRENEUR_PAROLE",
                "USCIS_PRIMARY_I_485J",
                "USCIS_PRIMARY_I_140",
                "USCIS_PRIMARY_J_1",
                "USCIS_PRIMARY_L_BLANKET",
                "USCIS_PRIMARY_L_1A",
                "USCIS_PRIMARY_L_1B",
                "USCIS_PRIMARY_NATIONAL_INTEREST_WAIVER",
                "USCIS_PRIMARY_N_400",
                "USCIS_PRIMARY_O_1",
                "USCIS_PRIMARY_O_2",
                "USCIS_PRIMARY_P_1",
                "USCIS_PRIMARY_P_3",
                "USCIS_PRIMARY_Q_1",
                "USCIS_PRIMARY_R_1",
                "USCIS_PRIMARY_RE_ENTRY_PERMIT",
                "USCIS_PRIMARY_SCHEDULE_A_GREEN_CARD",
                "USCIS_DEPENDENT_ADVANCE_PAROLE",
                "USCIS_DEPENDENT_B_1",
                "USCIS_DEPENDENT_B_2",
                "USCIS_DEPENDENT_DACA",
                "USCIS_DEPENDENT_E_1_DEPENDENT",
                "USCIS_DEPENDENT_E_2_DEPENDENT",
                "USCIS_DEPENDENT_EB_5_INVESTOR_I_526",
                "USCIS_DEPENDENT_EB_5_INVESTOR_I_829",
                "USCIS_DEPENDENT_F_1",
                "USCIS_DEPENDENT_F_2",
                "USCIS_DEPENDENT_I_130",
                "USCIS_DEPENDENT_I_140",
                "USCIS_DEPENDENT_I_751",
                "USCIS_DEPENDENT_INTENATIONAL_ENTREPRENEUR_PAROLE_DEPENDENT",
                "USCIS_DEPENDENT_J_2",
                "USCIS_DEPENDENT_K_1",
                "USCIS_DEPENDENT_L_2",
                "USCIS_DEPENDENT_N_400_CITIZENSHIP",
                "USCIS_DEPENDENT_O_3",
                "USCIS_DEPENDENT_P_4",
                "USCIS_DEPENDENT_Q_2",
                "USCIS_DEPENDENT_REENTRY_PERMIT",
                "USCIS_DEPENDENT_R_2",
                "USCIS_DEPENDENT_TEMPORARY_PROTECTED_STATUS",
                "H_1B_LOTTERY_CHANGE_OF_STATUS",
                "H_1B_LOTTERY_CONSULAR_NOTIFICATION",
                "H_1B_LOTTERY_24_CHANGE_OF_STATUS",
                "H_1B_LOTTERY_24_CONSULAR_NOTIFICATION",
                "H_1B_LOTTERY_MASTERS",
                "EAD_PRIMARY",
                "USCIS_PRIMARY_2_ADVANCE_PAROLE",
                "USCIS_PRIMARY_2_B_1",
                "USCIS_PRIMARY_2_B_2",
                "USCIS_PRIMARY_2_CONSULAR_PROCESSING",
                "USCIS_PRIMARY_2_EB_1A",
                "USCIS_PRIMARY_2_F_1",
                "USCIS_PRIMARY_2_I_130",
                "USCIS_PRIMARY_2_K_1",
                "USCIS_PRIMARY_2_I_485J",
                "USCIS_PRIMARY_2_NATIONAL_INTEREST_WAIVER",
                "USCIS_PRIMARY_2_N_400",
                "USCIS_PRIMARY_2_O_1",
                "USCIS_PRIMARY_2_RE_ENTRY_PERMIT",
                "USCIS_PRIMARY_2_U",
            ]
        },
        "ProcessRequestState": {
            "name": "ProcessRequestState",
            "values": [
                "REQUESTED",
                "APPROVED",
                "ARCHIVED"
            ]
        },
        "TaskCategory": {
            "name": "TaskCategory",
            "values": [
                "OPENING_CASE",
                "LCA_FILING",
                "PUBLIC_ACCESS_FILE",
                "PREPARING_MATERIALS",
                "APPLICATION_REVIEW",
                "SUBMITTING_APPLICATION",
                "RECEIPT_BY_GOVERNMENT",
                "PREMIUM_PROCESSING_UPGRADE",
                "REQUEST_FOR_EVIDENCE",
                "FINAL_DECISION"
            ]
        },
        "TaskState": {
            "name": "TaskState",
            "values": [
                "LOCKED",
                "TODO",
                "COMPLETED",
                "DELETED"
            ]
        },
        "CasePhase": {
            "name": "CasePhase",
            "values": [
                "APPLICATION_SUBMISSION",
                "CASE_OPENING",
                "CASE_PREPARATION",
                "DATA_COLLECTION",
                "FILE_I140",
                "FILE_PREVAILING_WAGE_REQUEST",
                "FINAL_DECISION",
                "FORMS_PREPARATION",
                "I140_PREPARATION",
                "LCA_FILING",
                "NEXT_STEPS",
                "PERM_SUBMISSION",
                "RECRUITMENT"
            ]
        },
        "CaseMilestone": {
            "name": "CaseMilestone",
            "values": [
                "APPLICATION_DECISION",
                "APPLICATION_SHIPPED",
                "APPROVAL_NOTICE_SHIPPED",
                "CASE_OPENED",
                "DOCUMENTS_UPLOADED",
                "EXPERIENCE_LETTERS_UPLOADED",
                "FINAL_DECISION",
                "FORMS_COMPLETED",
                "FORMS_PREPARED",
                "I140_APPLICATION_SHIPPED",
                "I140_CASE_OPENING",
                "I140_FORMS_PREPARED",
                "I140_RECEIPT_NOTICE_RECEIVED",
                "JOB_DESCRIPTION_FINALIZED",
                "LCA_FILED",
                "LCA_RECEIVED",
                "NEXT_STEPS",
                "PERM_CERTIFIED",
                "PERM_PREPARED",
                "PERM_REVIEWED",
                "PERM_SUBMITED",
                "PREVAILING_WAGE_DETERMINATION_RECEIVED",
                "PREVAILING_WAGE_REQUEST_FILED",
                "QUESTIONNAIRE_COMPLETED",
                "RECEIPT_NOTICE_RECEIVED",
                "RECRUITMENT_BEGUN",
                "RECRUITMENT_COMPLETE"
            ]
        },
        "PreparedFormState": {
            "name": "PreparedFormState",
            "values": [
                "TODO",
                "PREPARED",
                "AWAITING_ATTORNEY_APPROVAL",
                "AWAITING_NATIONAL_APPROVAL",
                "AWAITING_SPONSOR_APPROVAL",
                "AWAITING_FINAL_APPROVAL",
                "REJECTED",
                "COMPLETED"
            ]
        },
        "ActivityType": {
            "name": "ActivityType",
            "values": [
                "DOCUMENT_EXPIRATION_INCOMING",
                "DOCUMENT_UPLOADED",
                "DOCUMENT_UPLOAD_REQUESTED",
                "DOCUMENT_TYPE_COMPLETED",
                "PROCESS_REQUEST_SUBMITTED",
                "PROCESS_REQUEST_REASSIGNED",
                "PROCESS_REQUEST_ARCHIVED",
                "PROCESS_REQUEST_APPROVED",
                "PROCESS_REQUEST_RESUBMITTED",
                "CASE_COMMENT_ADDED",
                "CASE_MILESTONE_COMPLETED",
                "CASE_MILESTONE_UNCOMPLETED",
                "CASE_MILESTONE_RECEIPT_NUMBER_CHANGED",
                "CASE_FORM_PREPARED",
                "CASE_FORM_REJECTED",
                "CASE_FORM_RESET",
                "CASE_FORM_REVIEW_REQUESTED",
                "CASE_FORM_APPROVED",
                "CASE_FORM_COMPLETED",
                "CASE_TEAM_ATTORNEY_ADDED",
                "CASE_TEAM_MANAGER_ADDED",
                "CASE_TEAM_SPONSOR_ADDED",
                "CASE_TEAM_CONTRIBUTOR_ADDED",
                "CASE_COMPLETED",
                "CASE_CLOSED",
                "CASE_REOPENED",
                "LEGAL_TEAM_ATTORNEY_ADDED",
                "LEGAL_TEAM_PARALEGAL_ADDED",
                "LEGAL_TEAM_ACCOUNT_MANAGER_ADDED",
                "PROFILE_QUESTIONNAIRE_COMPLETED",
                "COMPANY_QUESTIONNAIRE_COMPLETED",
                "PROFILE_CREATED",
                "RELATIVE_ADMIN_QUESTIONNAIRE_COMPLETED",
                "COMPANY_PROFILE_UPDATED",
                "PERSON_PROFILE_UPDATED",
                "CASE_DETAIL_UPDATED",
                "FN_PROFILE_UPDATE_OPEN_CASE",
                "FN_PROFILE_UPDATE_NO_OPEN_CASE",
                "COMPLETE_REPORT_MANUALLY",
                "REPORT_SENT_MANUALLY",
                "USCIS_CASE_STATUS_UPDATED",
            ]
        },
        "PassportGender": {
            "name": "PassportGender",
            "values": [
                "MALE",
                "FEMALE"
            ]
        },
        "ExpenseDependentPetitions": {
            "name": "ExpenseDependentPetitions",
            "values": [
                "BOTH",
                "ONLY_DEPENDENT",
                "ONLY_EAD_CARDS",
                "NO"
            ]
        },
        "EducationEvaluation": {
            "name": "EducationEvaluation",
            "values": [
                "MH_SHOULD_GET",
                "MH_SHOULD_REACH_OUT",
                "COMPANY_WILL_PROVIDE"
            ]
        },
        "EmployeesEmailContactDirectly": {
            "name": "EmployeesEmailContactDirectly",
            "values": [
                "A_COMPANY_REPRESENTATIVE_SHOULD_BE_COPIED_ON_ALL_COMMUNICATION",
                "A_COMPANY_REPRESENTATIVE_WILL_ONLY_BE_COPIED_ON_INFORMATION_IMPACTING_THE_COMPANY_BUT_WILL_BE_LEFT_OFF_ON_COMMUNICATION_THAT_DOES_NOT_IMPACT_THE_COMPANY",
                "TRUE",
                "COMPANY_REPRESENTATIVE_COPIED",
                "FALSE"
            ]
        },
        "PaymentPreference": {
            "name": "PaymentPreference",
            "values": [
                "CHECK",
                "ACH",
                "CREDIT_CARD"
            ]
        },
        "CompanyEmployee": {
            "name": "CompanyEmployee",
            "values": [
                "COMPANY",
                "EMPLOYEE"
            ]
        },
        "PermissionReleasePetitionsRfe": {
            "name": "PermissionReleasePetitionsRfe",
            "values": [
                "TRUE",
                "YES_WITH_COMPANY_PERMISSION",
                "FALSE"
            ]
        },
        "PreferredShippingSpeedForDocuments": {
            "name": "PreferredShippingSpeedForDocuments",
            "values": [
                "OVERNIGHT",
                "TWO_DAYS",
                "SAVER"
            ]
        },
        "ShippingPaymentPreference": {
            "name": "ShippingPaymentPreference",
            "values": [
                "FEDEX",
                "UPS",
                "MH"
            ]
        },
        "UtilizePremiumProcessingService": {
            "name": "UtilizePremiumProcessingService",
            "values": [
                "ALWAYS_PAID",
                "CASE_BY_CASE",
                "PAID_BY_EMPLOYEE"
            ]
        },
        "TechnologyReleaseLicenseRequirement": {
            "name": "TechnologyReleaseLicenseRequirement",
            "values": [
                "REQUIRED",
                "NON_REQUIRED"
            ]
        },
        "ReadState": {
            "name": "ReadState",
            "values": [
                "READ",
                "UNREAD"
            ]
        },
        "PartnerPosition": {
            "name": "PartnerPosition",
            "values": [
                "PRINCIPAL",
                "SPECIALIST"
            ]
        },
        "Role": {
            "name": "Role",
            "values": [
                "TEAMMEMBER",
                "ADMIN",
                "FOREIGNNATIONAL",
                "EMPLOYER"
            ]
        },
        "SpecializationCountry": {
            "name": "SpecializationCountry",
            "values": [
                "US",
                "CANADA",
                "UK",
                "AUSTRALIA",
                "CHINA",
                "MEXICO"
            ]
        },
        "TaskAssignmentRole": {
            "name": "TaskAssignmentRole",
            "values": [
                "CASE_MANAGER",
                "ATTORNEY",
                "HIRING_MANAGER",
                "LEGAL_ASSISTANT",
                "FOREIGN_NATIONAL"
            ]
        },
        "FileCategory": {
            "name": "FileCategory",
            "values": [
                "COMPANY",
                "SIGNATURE_PAGES",
                "EDUCATION",
                "EMPLOYMENT",
                "EXPERIENCE_LETTER",
                "PERSONAL_IDENTIFICATION",
                "US_IMMIGRATION",
                "FORMS_LETTERS",
                "APPLICATIONS_APPROVALS",
                "OTHER"
            ]
        }
    },
    "nonModels": {
        "Picture": {
            "name": "Picture",
            "fields": {
                "original": {
                    "name": "original",
                    "isArray": false,
                    "type": {
                        "nonModel": "S3Object"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "square": {
                    "name": "square",
                    "isArray": false,
                    "type": {
                        "nonModel": "S3Object"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "squareThumbnails": {
                    "name": "squareThumbnails",
                    "isArray": true,
                    "type": {
                        "nonModel": "Thumbnail"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "thumbnails": {
                    "name": "thumbnails",
                    "isArray": true,
                    "type": {
                        "nonModel": "Thumbnail"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "version": {
                    "name": "version",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": true,
                    "attributes": []
                }
            }
        },
        "S3Object": {
            "name": "S3Object",
            "fields": {
                "bucket": {
                    "name": "bucket",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "region": {
                    "name": "region",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "key": {
                    "name": "key",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "level": {
                    "name": "level",
                    "isArray": false,
                    "type": {
                        "enum": "S3Level"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "identityId": {
                    "name": "identityId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "Thumbnail": {
            "name": "Thumbnail",
            "fields": {
                "image": {
                    "name": "image",
                    "isArray": false,
                    "type": {
                        "nonModel": "S3Object"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "size": {
                    "name": "size",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": true,
                    "attributes": []
                }
            }
        },
        "LoginStatus": {
            "name": "LoginStatus",
            "fields": {
                "isEnabled": {
                    "name": "isEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "UserStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "NationalOnboardingSections": {
            "name": "NationalOnboardingSections",
            "fields": {
                "background": {
                    "name": "background",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "contact": {
                    "name": "contact",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "employment": {
                    "name": "employment",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "family": {
                    "name": "family",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "immigration": {
                    "name": "immigration",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "personal": {
                    "name": "personal",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "StreetAddress": {
            "name": "StreetAddress",
            "fields": {
                "careOf": {
                    "name": "careOf",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "address": {
                    "name": "address",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "companyAddressType": {
                    "name": "companyAddressType",
                    "isArray": false,
                    "type": {
                        "enum": "CompanyAddressType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "unitNumber": {
                    "name": "unitNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "unitType": {
                    "name": "unitType",
                    "isArray": false,
                    "type": {
                        "enum": "UnitType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "adminArea": {
                    "name": "adminArea",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "state": {
                    "name": "state",
                    "isArray": false,
                    "type": {
                        "enum": "StateCode"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "city": {
                    "name": "city",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "country": {
                    "name": "country",
                    "isArray": false,
                    "type": {
                        "enum": "CountryCode"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "postalCode": {
                    "name": "postalCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "title": {
                    "name": "title",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "ImmigrationStatus": {
            "name": "ImmigrationStatus",
            "fields": {
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "VisaStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "doesNotExpire": {
                    "name": "doesNotExpire",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "expiration": {
                    "name": "expiration",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "J1J2": {
            "name": "J1J2",
            "fields": {
                "hasHad": {
                    "name": "hasHad",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "start": {
                    "name": "start",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "end": {
                    "name": "end",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "BooleanTwoPart": {
            "name": "BooleanTwoPart",
            "fields": {
                "value": {
                    "name": "value",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "followPrompt": {
                    "name": "followPrompt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "followValue": {
                    "name": "followValue",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "I140": {
            "name": "I140",
            "fields": {
                "hasApproved": {
                    "name": "hasApproved",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "classification": {
                    "name": "classification",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "employmentBasedCategory": {
                    "name": "employmentBasedCategory",
                    "isArray": false,
                    "type": {
                        "enum": "EmploymentBasedCategory"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "priorityDate": {
                    "name": "priorityDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "CriminalHistory": {
            "name": "CriminalHistory",
            "fields": {
                "tortureGenocide": {
                    "name": "tortureGenocide",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "killing": {
                    "name": "killing",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "severeInjuring": {
                    "name": "severeInjuring",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "nonconsensualSex": {
                    "name": "nonconsensualSex",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "religiousBelief": {
                    "name": "religiousBelief",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "BooleanExplain": {
            "name": "BooleanExplain",
            "fields": {
                "value": {
                    "name": "value",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "reason": {
                    "name": "reason",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "ProcessRequestEmployeeData": {
            "name": "ProcessRequestEmployeeData",
            "fields": {
                "firstname": {
                    "name": "firstname",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "lastname": {
                    "name": "lastname",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "middlename": {
                    "name": "middlename",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "email": {
                    "name": "email",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "tempID": {
                    "name": "tempID",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "spouse": {
                    "name": "spouse",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "dependents": {
                    "name": "dependents",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "ProcessRequestEmploymentData": {
            "name": "ProcessRequestEmploymentData",
            "fields": {
                "location": {
                    "name": "location",
                    "isArray": false,
                    "type": {
                        "nonModel": "ProcessRequestLocation"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "premiumProcessing": {
                    "name": "premiumProcessing",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "salary": {
                    "name": "salary",
                    "isArray": false,
                    "type": {
                        "nonModel": "Money"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "startDate": {
                    "name": "startDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "notes": {
                    "name": "notes",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "ProcessRequestLocation": {
            "name": "ProcessRequestLocation",
            "fields": {
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "ProcessRequestLocationType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "remoteAddress": {
                    "name": "remoteAddress",
                    "isArray": false,
                    "type": {
                        "nonModel": "StreetAddress"
                    },
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "Money": {
            "name": "Money",
            "fields": {
                "currency": {
                    "name": "currency",
                    "isArray": false,
                    "type": {
                        "enum": "Currency"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "amount": {
                    "name": "amount",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": true,
                    "attributes": []
                }
            }
        },
        "FileRequirement": {
            "name": "FileRequirement",
            "fields": {
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "FileType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "assignedToID": {
                    "name": "assignedToID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "isAssignedToLegalAssistants": {
                    "name": "isAssignedToLegalAssistants",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "expirationDateRequired": {
                    "name": "expirationDateRequired",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "issueDateRequired": {
                    "name": "issueDateRequired",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isApproved": {
                    "name": "isApproved",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isRequested": {
                    "name": "isRequested",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "CasePhaseRequirement": {
            "name": "CasePhaseRequirement",
            "fields": {
                "phase": {
                    "name": "phase",
                    "isArray": false,
                    "type": {
                        "enum": "CasePhase"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "milestones": {
                    "name": "milestones",
                    "isArray": true,
                    "type": {
                        "enum": "CaseMilestone"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                }
            }
        },
        "CompletedCaseMilestone": {
            "name": "CompletedCaseMilestone",
            "fields": {
                "completionDate": {
                    "name": "completionDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "completedByID": {
                    "name": "completedByID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "milestone": {
                    "name": "milestone",
                    "isArray": false,
                    "type": {
                        "enum": "CaseMilestone"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "receiptNumber": {
                    "name": "receiptNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "PreparedFormTemplate": {
            "name": "PreparedFormTemplate",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "file": {
                    "name": "file",
                    "isArray": false,
                    "type": {
                        "nonModel": "S3Object"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "processes": {
                    "name": "processes",
                    "isArray": true,
                    "type": {
                        "enum": "VisaStatus"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "archived": {
                    "name": "archived",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "requiresAttorneyApproval": {
                    "name": "requiresAttorneyApproval",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "requiresSponsorApproval": {
                    "name": "requiresSponsorApproval",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "requiresNationalApproval": {
                    "name": "requiresNationalApproval",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "employersCanView": {
                    "name": "employersCanView",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "nationalsCanView": {
                    "name": "nationalsCanView",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "ShippingPreference": {
            "name": "ShippingPreference",
            "fields": {
                "preference": {
                    "name": "preference",
                    "isArray": false,
                    "type": {
                        "enum": "ShippingPaymentPreference"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "fedexAccount": {
                    "name": "fedexAccount",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "upsAccount": {
                    "name": "upsAccount",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "KnowledgeCenterLink": {
            "name": "KnowledgeCenterLink",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "text": {
                    "name": "text",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "file": {
                    "name": "file",
                    "isArray": false,
                    "type": {
                        "nonModel": "S3Object"
                    },
                    "isRequired": true,
                    "attributes": []
                }
            }
        },
        "Shortcut": {
            "name": "Shortcut",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "text": {
                    "name": "text",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "link": {
                    "name": "link",
                    "isArray": false,
                    "type": "AWSURL",
                    "isRequired": true,
                    "attributes": []
                },
                "roles": {
                    "name": "roles",
                    "isArray": true,
                    "type": {
                        "enum": "Role"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                }
            }
        },
        "Address": {
            "name": "Address",
            "fields": {
                "address": {
                    "name": "address",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "unitNumber": {
                    "name": "unitNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "unitType": {
                    "name": "unitType",
                    "isArray": false,
                    "type": {
                        "enum": "UnitType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "adminArea": {
                    "name": "adminArea",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "city": {
                    "name": "city",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "country": {
                    "name": "country",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "postalCode": {
                    "name": "postalCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "title": {
                    "name": "title",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        }
    },
    "version": "574abf45fe80b6b2bdb01a613f976303",
    "codegenVersion": "3.4.4"
};